import {
  readBoolean,
  readDateIso,
  readString,
} from "./mapperUtils.js";

export type CmtsVerificationVm =
  Record<string, unknown> & {
    id: string;
    verificationId: string;
    complaintId: string;

    verificationRuleId: string;
    methodId: string;
    verificationMethod: string;

    verificationStatusId: string;
    verificationStatusName: string;
    status: string;

    verifierId: string;
    verifierUserId: string;
    verifierName: string;

    decision: string;
    result: string;
    closureReady: boolean;

    remarks: string;
    verifiedAt: string;
  };

function asRecord(
  dto: unknown,
): Record<string, unknown> {
  return dto &&
    typeof dto === "object" &&
    !Array.isArray(dto)
    ? (dto as Record<string, unknown>)
    : {};
}

export function mapVerification(
  dto: unknown,
): CmtsVerificationVm {
  const row = asRecord(dto);

  const id = readString(
    dto,
    ["id", "verificationId"],
    "",
  );

  const verificationId = readString(
    dto,
    ["verificationId", "id"],
    id,
  );

  const verificationStatusId = readString(
    dto,
    [
      "verificationStatusId",
      "statusId",
      "currentStatusId",
    ],
    "",
  );

  const verificationStatusName =
    readString(
      dto,
      [
        "verificationStatusName",
        "statusName",
        "status",
        "state",
      ],
      "",
    );

  const status =
    verificationStatusName ||
    readString(
      dto,
      [
        "status",
        "state",
        "result",
      ],
      "PENDING",
    );

  const verifierUserId = readString(
    dto,
    [
      "verifierUserId",
      "verifierId",
      "assignedVerifierId",
    ],
    "",
  );

  const verifierName = readString(
    dto,
    [
      "verifierName",
      "assignedVerifierName",
      "verifierDisplayName",
    ],
    "",
  );

  const decision = readString(
    dto,
    [
      "decision",
      "verificationDecision",
      "result",
    ],
    "Not decided",
  );

  const result = readString(
    dto,
    [
      "result",
      "effectivenessResult",
      "decision",
      "status",
    ],
    status,
  );

  return {
    ...row,

    id,
    verificationId,

    complaintId: readString(
      dto,
      ["complaintId", "linkedEntityId"],
      "",
    ),

    verificationRuleId: readString(
      dto,
      ["verificationRuleId", "ruleId"],
      "",
    ),

    methodId: readString(
      dto,
      [
        "methodId",
        "verificationMethodId",
      ],
      "",
    ),

    verificationMethod: readString(
      dto,
      [
        "verificationMethod",
        "methodName",
        "verificationMethodName",
        "method",
      ],
      "",
    ),

    verificationStatusId,
    verificationStatusName,
    status,

    verifierId: verifierUserId,
    verifierUserId,
    verifierName,

    decision,
    result,

    closureReady: readBoolean(
      dto,
      [
        "closureReady",
        "approved",
        "isClosureReady",
      ],
      false,
    ),

    remarks: readString(
      dto,
      [
        "remarks",
        "comments",
        "comment",
      ],
      "",
    ),

    verifiedAt: readDateIso(
      dto,
      [
        "verifiedAt",
        "verifiedAtUtc",
        "completedAt",
        "approvedAt",
      ],
      "",
    ),
  };
}